var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`md-icon is-${_vm.size} ${_vm.hoverable ? 'hoverable' : ''}`,domProps:{"innerHTML":_vm._s(_vm.svg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }